import Lottie from 'lottie-react';
import React from 'react';
// import {
//     Input,
//     InputGroup,
//     InputNumber,
//     InputPicker,
//     Toggle,
//     Tooltip,
//     Whisper,
// } from 'rsuite';
// import { confirmAlert } from 'react-confirm-alert';
import Dropdown from 'rsuite/esm/Dropdown';
import Input from 'rsuite/esm/Input';
import InputGroup from 'rsuite/esm/InputGroup';
import InputNumber from 'rsuite/esm/InputNumber';
import InputPicker from 'rsuite/esm/InputPicker';
import Toggle from 'rsuite/esm/Toggle';
import Tooltip from 'rsuite/esm/Tooltip';
import Whisper from 'rsuite/esm/Whisper';

import { PRODUCTS_LIST, ProductID, ProductPricePeriods } from '../../shared/products';
import { SystemShared } from '../../shared/system';
import { UserDataWeb } from '../../shared/userdataweb';
import { getAllLangs, langData, LangIdName, langString, langType } from '../../src/lang';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import CheckIcon from '@rsuite/icons/Check';
import CloseIcon from '@rsuite/icons/Close';
import { TypeAttributes } from 'rsuite/esm/@types/common';
import { OverlayTriggerType } from 'rsuite/esm/Overlay/OverlayTrigger';
import { EventSystem } from './events';
import { WebStorage } from '../storage';
import { CONTACTS_LIST, ContactType } from '../../shared/contacts';
import { NewsItem } from '../../shared/news';

export const Logo = require('../images/Logo.svg').default;

export const LogoText = require('../images/LogoText.svg').default;

export const LogoWhite = require('../images/LogoWhite.svg').default;

export const ShowNotify = (
    title: string,
    text: string,
    type: 'info' | 'success' | 'warning' | 'error' = 'info',
    timeout = 5000,
    onClick?: () => void,
) => {
    console.log('Show notify', title, text, type, timeout);

    NotificationManager[type](text, title, timeout, onClick);
};

(global as any).ShowNotify = ShowNotify;

export const sections: {
    id: string;
    name: string;
}[] = [
    { id: 'home', name: 'Main' },
    { id: 'dashboard', name: 'Dashboard' },
];

export const GetStreamAlertsPrev = React.memo(
    (props: {
        type: 'telegram' | 'discord';
        img?: string;
        mainText: string;
        buttons: string[];
        dsHeader?: string;
    }) => {
        const img = props.img;
        const mainText = props.mainText;
        const dsHeader = props.dsHeader;
        const buttons = props.buttons;

        return props.type === 'telegram' ? (
            <div className="showTelegram">
                <div className="title">Channel title</div>
                {img ? <img className="img" src={img} /> : <></>}
                <div className="content">{mainText}</div>
                <div className="buttons">
                    {buttons.map((q, i) => {
                        return (
                            <div className="button" key={i}>
                                {q}
                            </div>
                        );
                    })}
                </div>
            </div>
        ) : (
            <div className="showDiscord">
                {dsHeader ? <div className="prev">{dsHeader}</div> : <></>}
                {img ? <img className="img" src={img} /> : <></>}
                <div className="content">{mainText}</div>
                <div className="buttons">
                    {buttons.map((q, i) => {
                        return (
                            <div className="button" key={i}>
                                {q} <img src={require('../images/linkPrev.svg').default} />
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    },
);

export const GetPayPeriodItem = (index: number, cfg: (typeof PRODUCTS_LIST)[number]) => {
    const q = ProductPricePeriods[index];

    if (!q) {
        return undefined;
    }

    if (!cfg) {
        return undefined;
    }

    const sum = parseFloat(
        (cfg.price * q.multiple - ((cfg.price * q.multiple) / 100) * q.percent).toFixed(2),
    );

    return [
        'WebOrderControlPayPeriod',
        cfg.priceDuration * q.multiple,
        `$${sum}`,
        q.percent ? `(-${q.percent}%)` : '',
    ] as [langData, number, string, string];
};

export const LangSelection = React.memo((props?: { small?: boolean }) => {
    const [lang, setLang, LangString] = LangBlock();

    return (
        <>
            {props?.small ? (
                <>
                    <Dropdown
                        placement="topStart"
                        className="langSelect"
                        noCaret={true}
                        title={
                            <>
                                <img
                                    alt={LangString(`langName_${lang}` as any)}
                                    src={require(`../images/flags/${lang}.svg`).default}
                                />
                            </>
                        }
                        onClick={(e) => {
                            e.preventDefault();

                            const index = getAllLangs().indexOf(lang) + 1;
                            const key = getAllLangs()[index] || getAllLangs()[0];

                            setLang(key);
                        }}
                    />
                </>
            ) : (
                <Dropdown
                    placement="topStart"
                    className="langSelect"
                    title={
                        <>
                            <img
                                alt={LangString(`langName_${lang}` as any)}
                                src={require(`../images/flags/${lang}.svg`).default}
                            />{' '}
                            {LangString(`langName_${lang}` as any)}
                        </>
                    }
                >
                    {getAllLangs().map((key) => {
                        return (
                            <Dropdown.Item
                                key={key}
                                onClick={(e) => {
                                    e.preventDefault();
                                    setLang(key);
                                }}
                            >
                                <img
                                    alt={LangString(`langName_${key}` as any)}
                                    src={require(`../images/flags/${key}.svg`).default}
                                />{' '}
                                {LangString(`langName_${key}` as any)}
                            </Dropdown.Item>
                        );
                    })}
                </Dropdown>
            )}
        </>
    );
});

const contactIconSrc = (type: ContactType) => {
    if (type === 'discord') {
        return require('../images/platforms/discord.svg').default;
    }

    return require(`../images/${type}.svg`).default;
};

const contactLabelKey = (type: ContactType) => {
    if (type === 'email') {
        return 'ServiceContactsEmail' as const;
    }

    if (type === 'tg') {
        return 'ServiceContactsTelegram' as const;
    }

    return 'ServiceContactsDiscord' as const;
};

export const Footer = React.memo(() => {
    const [, , LangString] = LangBlock();

    const [contactsOpened, setContactsOpened] = React.useState(false);

    const openSupportChat = (e: React.MouseEvent) => {
        e.preventDefault();
        setContactsOpened(false);
        EventSystem.emit('openSupportBoard');
    };

    return (
        <>
            {contactsOpened ? (
                <>
                    <div className="modalBG">
                        <div
                            className="modalBG2"
                            onClick={(e) => {
                                e.preventDefault();
                                setContactsOpened(false);
                            }}
                        ></div>
                        <div className="modalMain">
                            <div className="title">{LangString('ServiceCONTACTS')}</div>
                            <div className="content">
                                <div className="footerContactList">
                                    {CONTACTS_LIST.map((item) => {
                                        return (
                                            <div className="footerContactRow" key={item.type}>
                                                <img src={contactIconSrc(item.type)} alt="" />
                                                <div className="footerContactBody">
                                                    <div className="footerContactLabel">
                                                        {LangString(contactLabelKey(item.type))}
                                                    </div>
                                                    <a
                                                        className="footerContactValue"
                                                        target="_blank"
                                                        rel="noreferrer"
                                                        href={item.url}
                                                    >
                                                        {item.value}
                                                    </a>
                                                    {item.type === 'discord' ? (
                                                        <div className="footerContactHint">
                                                            {LangString(
                                                                'ServiceContactsDiscordHint',
                                                            )}
                                                        </div>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                                <button
                                    type="button"
                                    className="footerChatBtn"
                                    onClick={openSupportChat}
                                >
                                    <img src={require('../images/message.svg').default} alt="" />
                                    {LangString('ServiceWriteUs')}
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <></>
            )}
            <footer className="footerBlock">
                <div className="footerInner">
                    <div className="footerBrand">
                        <a className="footerBrandLink" href="https://RocketMan-Streams.com/">
                            <img alt="RocketMan" src={LogoWhite} />
                            RocketMan-Streams.com
                        </a>
                        <div className="footerCopy">
                            &copy; 2023-{new Date().getFullYear()}
                        </div>
                    </div>
                    <div className="footerCol">
                        <div className="footerColTitle">{LangString('ServiceFooterHelp')}</div>
                        <a href="#help" target="_blank">
                            {LangString('ServiceHELP')}
                        </a>
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                setContactsOpened(true);
                            }}
                        >
                            {LangString('ServiceCONTACTS')}
                        </a>
                        <button type="button" className="footerChatBtn" onClick={openSupportChat}>
                            <img src={require('../images/message.svg').default} alt="" />
                            {LangString('ServiceWriteUs')}
                        </button>
                    </div>
                    <div className="footerCol">
                        <div className="footerColTitle">{LangString('ServiceFooterLegal')}</div>
                        <a href="#terms" target="_blank">
                            {LangString('ServiceLicense')}
                        </a>
                        <a href="#privacy" target="_blank">
                            {LangString('ServicePrivacy')}
                        </a>
                    </div>
                    <div className="footerLang">
                        <div className="language-picker">
                            <LangSelection />
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
});

export const FadeSection = React.memo((props: any) => {
    const [isVisible, setVisible] = React.useState(false);
    const domRef = React.useRef();

    React.useEffect(() => {
        if (!domRef.current) {
            return;
        }

        if (isVisible) {
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => setVisible(entry.isIntersecting));
        });

        observer.observe(domRef.current);

        return () => {
            if ((domRef as any).current) {
                observer.unobserve((domRef as any).current as any);
            }
        };
    }, [domRef, isVisible]);

    return (
        <div className={`fade-in-section ${isVisible ? 'is-visible' : ''}`} ref={domRef as any}>
            {props.children}
        </div>
    );
});

export const SVGAnim = (id: string, className?: string) => {
    return (
        <Lottie className={className} animationData={require(`../lottie/${id}.json`)} loop={true} />
    );
};

export const ProductIcon = (type: ProductID, white = false) => {
    const exts: string[] = ['svg', 'png', 'jpg'];
    const names = white ? [`${type}_white`, `${type}`] : [`${type}`, `${type}_white`];

    for (const name of names) {
        for (const ext of exts) {
            try {
                const itm = require(`../images/products/${name}.${ext}`);

                if (itm) {
                    return itm.default;
                }
            } catch (error) {}
        }
    }

    return null;
};

export function inputBlock(
    type: 'toggle',
    value: boolean,
    onChange: (value: boolean) => void,
    placeholder?: any | [any, any],
    size?: 'lg' | 'md' | 'sm',
): JSX.Element;

export function inputBlock(
    type: 'text',
    value: string,
    onChange: ((value: string) => void) | null,
    placeholder?: string,
    size?: 'lg' | 'md' | 'sm' | 'xs',
    buttonRight?: { label: string; click: () => void },
): JSX.Element;

export function inputBlock<T>(
    type: 'select',
    value: T,
    onChange: ((value: T) => void) | null,
    items: { label: any; value: T }[],
    size?: 'lg' | 'md' | 'sm' | 'xs',
): JSX.Element;

export function inputBlock(
    type: 'number',
    value: number,
    onChange: ((value: number) => void) | null,
    placeholder?: string,
    size?: 'lg' | 'md' | 'sm' | 'xs',
): JSX.Element;

export function inputBlock(
    type: 'number',
    value: number,
    onChange: ((value: number) => void) | null,
    placeholder: string | undefined,
    size: 'lg' | 'md' | 'sm' | 'xs',
    min: number,
    max: number,
    step: number,
): JSX.Element;

export function inputBlock(
    type: 'text' | 'number' | 'select' | 'toggle',
    value: any,
    onChange?: ((value: any) => void) | null,
    placeholder?: any,
    size: 'lg' | 'md' | 'sm' | 'xs' = 'md',
    min?: any,
    max?: any,
    step: number = 1,
) {
    return (
        <>
            {type === 'toggle' ? (
                <Toggle
                    checkedChildren={
                        (placeholder instanceof Array ? placeholder[0] : placeholder) || (
                            <CheckIcon />
                        )
                    }
                    unCheckedChildren={
                        placeholder instanceof Array ? placeholder[1] : <CloseIcon />
                    }
                    checked={value}
                    size={size}
                    readOnly={!onChange}
                    onChange={(e) => {
                        if (onChange) {
                            onChange(e);
                        }
                    }}
                />
            ) : type === 'select' ? (
                <InputPicker
                    placement="auto"
                    data={placeholder}
                    value={value}
                    size={size}
                    readOnly={!onChange}
                    cleanable={false}
                    onChange={(e) => {
                        if (onChange) {
                            onChange(e);
                        }
                    }}
                />
            ) : type === 'text' ? (
                <>
                    <InputGroup size={size}>
                        {typeof value === 'string' && placeholder ? (
                            <InputGroup.Addon>{placeholder}</InputGroup.Addon>
                        ) : (
                            <></>
                        )}
                        <Input
                            placeholder={typeof value !== 'string' ? placeholder : undefined}
                            value={value}
                            size={size}
                            readOnly={!onChange}
                            onChange={(e) => {
                                if (onChange) {
                                    onChange(e);
                                }
                            }}
                        />
                        {typeof min === 'object' ? (
                            <>
                                <InputGroup.Button
                                    onClick={(e) => {
                                        e.preventDefault();
                                        min.click();
                                    }}
                                >
                                    {min.label}
                                </InputGroup.Button>
                            </>
                        ) : (
                            <></>
                        )}
                    </InputGroup>
                </>
            ) : (
                <InputNumber
                    placeholder={typeof value !== 'number' ? placeholder : undefined}
                    prefix={typeof value === 'number' && placeholder ? placeholder : undefined}
                    value={value}
                    size={size}
                    min={min}
                    max={max}
                    step={step}
                    readOnly={!onChange}
                    onChange={(e) => {
                        if (onChange) {
                            onChange(
                                typeof e === 'string'
                                    ? step % 1 === 0
                                        ? parseInt(e)
                                        : parseFloat(e)
                                    : e,
                            );
                        }
                    }}
                />
            )}
        </>
    );
}

type DropDownItem = { val: any; title: string; active?: boolean; locked?: boolean };

export const DropDownBlock = (
    left: string | undefined,
    title: string,
    items: (DropDownItem | undefined)[],
    onClick: (val: any) => void,
    size: TypeAttributes.Size = 'md',
    rightButton?: { label: string; click: () => void },
    placement: TypeAttributes.Placement8 = 'bottomEnd',
) => {
    return (
        <>
            <InputGroup size={size}>
                {left ? <InputGroup.Addon>{left}</InputGroup.Addon> : <></>}
                <Dropdown title={title} placement={placement}>
                    {items
                        .filter((q): q is DropDownItem => !!q)
                        .map((item, i) => {
                            return (
                                <Dropdown.Item
                                    key={i}
                                    active={!!item.active}
                                    disabled={!!item.locked}
                                    onClick={(e) => {
                                        e.preventDefault();

                                        onClick(item.val);
                                    }}
                                >
                                    {item.title}
                                </Dropdown.Item>
                            );
                        })}
                </Dropdown>
                {typeof rightButton === 'object' ? (
                    <>
                        <InputGroup.Button
                            onClick={(e) => {
                                e.preventDefault();
                                rightButton.click();
                            }}
                        >
                            {rightButton.label}
                        </InputGroup.Button>
                    </>
                ) : (
                    <></>
                )}
            </InputGroup>
        </>
    );
};

// export const OptionSelect = (
//     items: ({ label: string; value: any } | undefined)[],
//     onSelect?: (value: any) => void,
//     value?: any,
// ) => {
//     return (
//         <select
//             className="form-select"
//             value={value}
//             onChange={(e) => {
//                 const val = e.target.value;

//                 if (onSelect) {
//                     onSelect(val);
//                 }
//             }}
//         >
//             {items
//                 .filter((q) => q)
//                 .map((item: { label: string; value: any }, i) => {
//                     return (
//                         <option key={i} value={item.value}>
//                             {item.label}
//                         </option>
//                     );
//                 })}
//         </select>
//     );
// };

export const ContentBlock = React.memo(
    (props: { lg?: number; sm?: number; md?: number; children?: JSX.Element | JSX.Element[] }) => {
        const lg = props.lg || 6;
        const md = props.md || 8;
        const sm = props.sm || 12;

        const lg2 = Math.floor((12 - lg) / 2);
        const md2 = Math.floor((12 - md) / 2);
        const sm2 = Math.floor((12 - sm) / 2);

        const sec = <div className={`col-lg-${lg2} col-md-${md2} col-sm-${sm2}`}></div>;

        const main = (
            <div className={`col-lg-${lg} col-md-${md} col-sm-${sm}`}>{props.children}</div>
        );

        return (
            <div className="row">
                {sec}
                {main}
                {sec}
            </div>
        );
    },
);

export const DiscordName = (name: string) => {
    return name.endsWith('#0') ? name.replace('#0', '') : name;
};

export const HWID_Display = (id: string) => {
    return id
        .split('')
        .map((q, i) => {
            return [1, 2, 3, 4].includes(i) ? '*' : q;
        })
        .join('');
};

export const PlatformIcon = (id: string) => {
    try {
        const q = require(`../images/platforms/${id}.svg`);

        return q?.default ?? q ?? '';
    } catch (error) {
        return '';
    }
};

export const DrawToolTip = React.memo(
    (props: {
        children: JSX.Element;
        text: string | JSX.Element;
        leftText?: boolean;
        arrow?: boolean;
        placement?: TypeAttributes.Placement;
        trigger?: OverlayTriggerType;
    }) => {
        return (
            <Whisper
                placement={props.placement || 'top'}
                trigger={props.trigger || 'click'}
                speaker={
                    <Tooltip
                        arrow={typeof props.arrow === 'boolean' ? props.arrow : false}
                        className={props.leftText ? 'tooltipObjectSText' : 'tooltipObjectText'}
                    >
                        {props.text}
                    </Tooltip>
                }
            >
                {props.children}
            </Whisper>
        );
    },
);

export const AcceptBlock = (text?: string, title?: string) => {
    return new Promise<boolean>((resolve) => {
        return resolve(confirm(text || langString(WebStorage.lang, 'confirm')));
        // confirmAlert({
        //     title,
        //     message: text || langString(WebStorage.lang, 'confirm'),
        //     buttons: [
        //         {
        //             label: langString(WebStorage.lang, 'confirm_yes'),
        //             onClick: () => resolve(true),
        //         },
        //         {
        //             label: langString(WebStorage.lang, 'confirm_no'),
        //             onClick: () => resolve(false),
        //         },
        //     ],
        // });
    });
    // return confirm(text || langString(WebStorage.lang, 'confirm'));
};

// export const LangSelect = () => {
//     const [lang, setLang, LangString] = LangBlock();

//     return (
//         <div className="language-picker">
//             <Dropdown
//                 placement="topStart"
//                 className="langSelect"
//                 title={
//                     <>
//                         <img src={require(`../images/flags/${lang}.svg`).default} />{' '}
//                         {LangString(`langName_${lang}` as any)}
//                     </>
//                 }
//             >
//                 {getAllLangs().map((key) => {
//                     return (
//                         <Dropdown.Item
//                             key={key}
//                             onClick={(e) => {
//                                 e.preventDefault();
//                                 setLang(key);
//                             }}
//                         >
//                             <img src={require(`../images/flags/${key}.svg`).default} />{' '}
//                             {LangString(`langName_${key}` as any)}
//                         </Dropdown.Item>
//                     );
//                 })}
//             </Dropdown>
//         </div>
//     );
// };

export const LangBlock = (onChangeLang?: (newLang: langType) => void) => {
    let userLang = navigator.language;

    if (userLang.includes(userLang)) {
        userLang = userLang.split('-')[0].toLowerCase();
    }

    const [lang, setLang] = React.useState<langType>(
        () =>
            (localStorage.getItem('lang') as any) ||
            (getAllLangs().includes(userLang as any) ? userLang : getAllLangs()[0]),
    );

    React.useEffect(() => {
        localStorage.setItem('lang', lang);
        console.log('Change lang to', lang);
        EventSystem.emit('setLang', lang);
        WebStorage.lang = lang;
    }, [lang]);

    React.useEffect(() => {
        const q = EventSystem.on('setLang', (lang) => {
            // setLang((old) => {
            //     if (old !== lang) {
            //         EventSystem.emit('setLang', lang);
            //     }

            //     return lang;
            // });
            setLang(lang);
        });

        return () => {
            q?.destroy();
        };
    }, []);

    const LangString = React.useCallback(
        (
            id: langData | { [lang in langType]?: string },
            ...args: (number | string | boolean)[]
        ) => {
            if (typeof id === 'object') {
                const text = id[lang] || (lang === 'uk' ? id['uk'] : undefined) || id['en'] || '';

                return text;
            } else {
                return langString(lang, id, ...args);
            }
        },
        [lang],
    );

    return [lang, setLang, LangString] as [
        langType,
        React.Dispatch<React.SetStateAction<langType>>,
        (id: langData, ...args: (number | string | boolean)[]) => string,
    ];
};

export const LangString = () => {
    const [lang, setLang] = React.useState<langType>(
        () => (localStorage.getItem('lang') as any) || getAllLangs()[0],
    );

    React.useEffect(() => {
        localStorage.setItem('lang', lang);
        console.log('Change lang to', lang);
        EventSystem.emit('setLang', lang);
        document.getElementsByTagName('html')[0].setAttribute('lang', lang);
    }, [lang]);

    React.useEffect(() => {
        const q = EventSystem.on('setLang', (lang) => {
            // setLang((old) => {
            //     if (old !== lang) {
            //         EventSystem.emit('setLang', lang);
            //     }

            //     return lang;
            // });
            setLang(lang);
        });

        return () => {
            q?.destroy();
        };
    }, []);

    const LangString = React.useCallback(
        (id: langData, ...args: (number | string | boolean)[]) => {
            return langString(lang, id, ...args);
        },
        [lang],
    );

    return [lang, setLang, LangString] as [
        langType,
        React.Dispatch<React.SetStateAction<langType>>,
        (id: langData, ...args: (number | string | boolean)[]) => string,
    ];
};

export const TextAreaEditor = React.memo(
    (props: {
        name: string;
        value: string;
        onChange: (val: string) => void;
        helps: [string, string][];
        reset?: string;
        onChangeTrigger?: 'button' | 'onchange';
    }) => {
        const [value, setValue] = React.useState(() => props.value);
        const [show, setShow] = React.useState(false);
        const [lang, setLang, LangString] = LangBlock();

        React.useEffect(() => {
            setValue(() => props.value);
        }, [show]);

        React.useEffect(() => {
            setValue(() => props.value);
        }, [props.value]);

        const btn = (
            <button
                className={`btn linkButton ${show ? 'remove' : ''} btn-block`}
                onClick={(e) => {
                    e.preventDefault();

                    setShow((old) => !old);
                }}
            >
                <div>
                    <img src={require('../images/show.svg').default} /> {props.name}
                </div>
            </button>
        );

        const helpButton = (
            <>
                {props.helps?.length ? (
                    <DrawToolTip
                        text={props.helps.map((q) => `%${q[0]}% - ${q[1]}`).join('\n')}
                        trigger="hover"
                        leftText={true}
                    >
                        <button
                            className="btn linkButton btn-block"
                            onClick={(e) => {
                                e.preventDefault();
                            }}
                        >
                            <div>
                                <img src={require('../images/info.svg').default} />{' '}
                                {LangString('WebOrderHelpText')}
                            </div>
                        </button>
                    </DrawToolTip>
                ) : (
                    <></>
                )}
            </>
        );

        const resetButton =
            props.reset && props.reset !== value ? (
                <DrawToolTip text={props.reset} trigger="hover" leftText={true}>
                    <button
                        className="btn linkButton btn-block"
                        onClick={async (e) => {
                            e.preventDefault();

                            if (props.reset && (await AcceptBlock())) {
                                setValue(props.reset);
                            }
                        }}
                    >
                        <div>
                            <img src={require('../images/reset.svg').default} />{' '}
                            {LangString('WebOrderHelpReset')}
                        </div>
                    </button>
                </DrawToolTip>
            ) : null;

        return (
            <div className="textAreaZone">
                <div className="textAreaZoneInside" style={{ display: show ? 'block' : 'none' }}>
                    {resetButton ? (
                        <div className="row">
                            <div className="col-6">{helpButton}</div>
                            <div className="col-6">{resetButton}</div>
                        </div>
                    ) : (
                        <>{props.helps?.length > 0 ? helpButton : <></>}</>
                    )}
                    <Input
                        as="textarea"
                        rows={5}
                        placeholder={LangString('PlaceholderText')} //
                        value={value}
                        onChange={(val) => {
                            setValue(val);

                            if (props.onChangeTrigger === 'onchange') {
                                props.onChange(val);
                            }
                        }}
                    />
                    {!props.onChangeTrigger || props.onChangeTrigger === 'button' ? (
                        <button
                            className="btn linkButton btn-block btn-success"
                            disabled={props.value === value}
                            onClick={(e) => {
                                e.preventDefault();

                                if (props.value === value) {
                                    return;
                                }

                                props.onChange(value);
                            }}
                        >
                            <div>
                                <img src={require('../images/update.svg').default} />{' '}
                                {LangString('WebOrderSaveText')}
                            </div>
                        </button>
                    ) : (
                        <></>
                    )}
                </div>

                {!show ? (
                    <DrawToolTip
                        leftText={true}
                        trigger="hover"
                        text={value?.replace(/\\n/g, '<br/>')}
                    >
                        {btn}
                    </DrawToolTip>
                ) : (
                    btn
                )}
            </div>
        );
    },
);

export const loadAllNews = () => {
    return new Promise<NewsItem[] | undefined>((resolve) => {
        fetch('/api/getAllNews')
            .then((res) => {
                res.json()
                    .then(async (data) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        resolve(undefined);
                    });
            })
            .catch((err) => {
                resolve(undefined);
            });
    });
};
